import LegalLayout from "@/components/LegalLayout";
import SEO from "@/components/SEO";

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service"
        description="Terms governing use of the United Techlab website and services."
        path="/terms"
      />
      <LegalLayout
        eyebrow="> /legal/terms"
        title="Terms of Service"
        lastUpdated="December 2025"
      >
        <p>
          These terms govern your use of the United Techlab website and services.
          By accessing this site or engaging our services, you agree to these
          terms.
        </p>

        <h2>1. Our services</h2>
        <p>
          United Techlab provides IT services (modernization, development,
          cloud, DevOps, consulting, data & AI engineering) and enterprise
          software products. Specific engagements are governed by a separate
          statement of work or master services agreement.
        </p>

        <h2>2. Acceptable use</h2>
        <ul>
          <li>
            Do not use this website to perform unauthorised access, scraping
            beyond reasonable use, or to introduce malicious code.
          </li>
          <li>Do not misrepresent yourself or your affiliation.</li>
        </ul>

        <h2>3. Intellectual property</h2>
        <p>
          All content, branding, code samples and product imagery on this site
          are the property of United Techlab unless otherwise noted and may not
          be reproduced without permission.
        </p>

        <h2>4. Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, United Techlab is not liable
          for indirect, incidental, or consequential damages arising from the
          use of this website. Liability for paid engagements is governed by the
          applicable master services agreement.
        </p>

        <h2>5. Confidentiality</h2>
        <p>
          Information you share with us via the contact form or email is treated
          as confidential and used only for the purpose of responding to your
          request.
        </p>

        <h2>6. Governing law</h2>
        <p>
          These terms are governed by the laws applicable to the jurisdiction in
          which United Techlab is registered. Disputes will be handled in
          appropriate competent courts.
        </p>

        <h2>7. Changes</h2>
        <p>
          We may update these terms periodically. Continued use of the website
          after changes constitutes acceptance.
        </p>

        <h2>8. Contact</h2>
        <p>
          For any questions, email{" "}
          <a href="mailto:contact@unitedtechlab.com">contact@unitedtechlab.com</a>.
        </p>
      </LegalLayout>
    </>
  );
}
